import axios from 'axios';
import { toolUtils } from '../../../../utils/toolUtils.js'
import pfn from './BankFns.js'
import { message, Upload } from 'antd';
export default {
  createBank: async function (conferenceUid, values, setFuncMap) {
    let payload = {
      "name": values.name,
    }
    try {
      setFuncMap.setIsModalLoading(true)
      const res = await this.createBankAction(conferenceUid, payload)
      pfn.getBanks({ conferenceUid }, setFuncMap)
      setFuncMap.setIsModalLoading(false)
      setFuncMap.setIsModalOpen(false)
      setFuncMap.message.open({
        key: "create",
        type: 'success',
        content: 'Create success',
        duration: 2,
      });
    }
    catch (error) {
      setFuncMap.message.open({
        type: 'error',
        content: setFuncMap.t(`error.${error.response.status}`, { data: payload.name }),
        duration: 2,
      });
      setFuncMap.setIsModalLoading(false)
    }

  },
  createBankAction: (conferenceUid, payload) => {
    return axios.post(`/conference/${conferenceUid}/bank`, payload, {
      headers: {
        "role": "topUser"
      }
    })
  },
  getBankById: async function (conferenceUid, id, setFuncMap) {
    try {
      const res = await this.getBankByIdAction(conferenceUid, id);
      let data = res.data
      if (data) {
        setFuncMap.setFieldsValue(data)
      }
    }
    catch (e) {

    }

  },
  getBankByIdAction: (conferenceUid, id) => {
    return axios.get(`/conference/${conferenceUid}/bank/${id}`, {
      headers: {
        "role": "topUser"
      }
    })
  },
  updateBank: async function (conferenceUid, values, setFuncMap) {
    let payload = {
      "id": values.id,
      "name": values.name,
    }
    try {
      setFuncMap.setIsModalLoading(true)
      console.log({ payload })
      const res = await this.updateBankAction(conferenceUid, payload)
      pfn.getBanks({ conferenceUid }, setFuncMap)
      setFuncMap.setIsModalLoading(false)
      setFuncMap.setIsModalOpen(false)
      setFuncMap.message.open({
        key: "update",
        type: 'success',
        content: 'Update success',
        duration: 2,
      });
    }
    catch (error) {
      setFuncMap.message.open({
        type: 'error',
        content: setFuncMap.t(`error.${error.response.status}`, { data: payload.name }),
        duration: 2,
      });
      setFuncMap.setIsModalLoading(false)
    }

  },
  updateBankAction: (conferenceUid, payload) => {
    return axios.post(`/conference/${conferenceUid}/bank/${payload.id}`, payload, {
      headers: {
        "role": "topUser"
      }
    })
  }
}